import { EnrollmentHelpText } from '@/shared/components/layout/EnrollmentHelpText'
import { EnvelopeAnimation } from '@/shared/components'
import { StepHeader } from './StepHeader'
import { EnrollmentDetailsSummary } from './studentEnrolledDetails/EnrollmentDetailsSummary'
import { useEnrollmentDetailsData } from './studentEnrolledDetails/useEnrollmentDetailsData'

interface StudentEnrolledDetailsProps {
  onBack: () => void
  currentStep: number
  totalSteps: number
}

export function StudentEnrolledDetails({
  onBack,
  currentStep,
  totalSteps
}: StudentEnrolledDetailsProps) {
  const { data, isLoading } = useEnrollmentDetailsData()

  return (
    <div className="animate-fade-in-up">
      <StepHeader
        currentStep={currentStep}
        totalSteps={totalSteps}
        onBack={onBack}
        showBackButton={false}
      />

      <div className="mx-auto max-w-2xl px-4 py-8">
        <div className="relative flex flex-col items-center justify-center">
          <div className="absolute left-0 top-0 -z-10 h-32 w-32 rounded-full bg-primary/10 blur-2xl" />
          <div className="absolute right-0 top-0 -z-10 h-24 w-24 rounded-full bg-yellow-300/20 blur-2xl" />
          <div className="absolute left-1/2 top-0 -z-10 h-16 w-16 -translate-x-1/2 rounded-full bg-green-300/20 blur-2xl" />
          <EnvelopeAnimation size={72} />
          <h2 className="mt-6 text-3xl font-extrabold text-primary drop-shadow-sm animate-fade-in-up">
            Congratulations!
          </h2>
          <p className="mt-2 text-lg font-medium text-gray-700 animate-fade-in-up">
            You are officially enrolled with{' '}
            <span className="text-primary font-bold">160 Driving Academy</span>!
          </p>
        </div>

        {isLoading ? (
          <div className="mt-10 animate-pulse">
            <div className="mt-10 grid gap-6 md:grid-cols-4">
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="flex flex-col items-center">
                  <div className="mb-2 h-12 w-12 rounded-full bg-gray-200" />
                  <div className="mb-2 h-3 w-20 rounded-full bg-gray-200" />
                  <div className="h-5 w-28 rounded-full bg-gray-200" />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <EnrollmentDetailsSummary data={data} />
        )}

        <div className="mt-8 flex flex-col items-center">
          <p className="flex max-w-[600px] items-center text-center text-[16px] font-normal leading-[1.7] text-[#707070]">
            You will receive a confirmation email and text shortly.
            <br />
            Please remember to bring your Driver&apos;s License with you to your appointment.
          </p>

          <div className="mt-6 text-center">
            <EnrollmentHelpText />
          </div>
        </div>
      </div>
    </div>
  )
}
